import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import CommonLoader from '@/components/CommonLoader';
import { useAuth } from '@/contexts/AuthContext';
import { RootState } from '@/store';

import { themeFromConfig } from './schemes/ThemeConfig';
import defaultThemeJson from './theme.json';

interface ThemeProviderWrapperProps {
  children: React.ReactNode;
}

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = ({
  children,
}) => {
  const { tenantInfo } = useAuth();
  const [themeJson, setThemeJson] = useState<any>(defaultThemeJson);

  const theme = useMemo(() => themeFromConfig(themeJson), [themeJson]);
  const { mode } = useSelector((state: RootState) => state.tenant.themeMode);
  useEffect(() => {
    if (tenantInfo) {
      const updatedTheme = {
        ...defaultThemeJson,
        colors: {
          ...defaultThemeJson.colors,
          primary:
            mode === 'light'
              ? tenantInfo.lightThemePrimaryColorHex ||
                defaultThemeJson.colors.primary
              : tenantInfo.darkThemePrimaryColorHex ||
                defaultThemeJson.colors.primary,
          secondary:
            mode === 'light'
              ? tenantInfo.lightThemeSecondaryColorHex ||
                defaultThemeJson.colors.secondary
              : tenantInfo.darkThemeSecondaryColorHex ||
                defaultThemeJson.colors.secondary,
        },
      };
      setThemeJson(updatedTheme);
    } else {
      setThemeJson(defaultThemeJson);
    }
  }, [tenantInfo, mode]);

  if (!themeJson) {
    return <CommonLoader isLoading={true} />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
